import { send } from "vite"
import { authService } from "../services/auth.service"

export class SignInView {
  sentCallBack: Function
  element: HTMLDialogElement
  sendBtn: HTMLButtonElement
  closeBtn: HTMLButtonElement
  emailDisplayElem: HTMLSpanElement
  emailInput: HTMLInputElement

  constructor(element: HTMLDialogElement, sentCallBack: Function) {
    this.sentCallBack = sentCallBack

    this.element = element
    const closeBtn = document.querySelector<HTMLButtonElement>("#sign-in-container button.close")
    const emailDisplayElem = document.querySelector<HTMLSpanElement>("#otp-send-email")
    const emailInput = document.querySelector<HTMLInputElement>('dialog input[type=email')
    const sendBtn = this.element.querySelector<HTMLButtonElement>('button.send-email')

    if (!closeBtn || !emailInput || !emailDisplayElem || !sendBtn) { throw new Error("Element(s) missing") }
    this.closeBtn = closeBtn
    this.emailInput = emailInput
    this.emailDisplayElem = emailDisplayElem
    this.sendBtn = sendBtn

    this.emailInput.addEventListener('input', this.onEmailChanged)
    this.closeBtn.addEventListener('click', this.onCloseBtnClick)
    this.sendBtn.addEventListener('click', this.onSendEmailBtnClick)
  }

  open() {
    this.emailInput.disabled = false
    this.sendBtn.disabled = true
    this.emailInput.value = ''
    this.element.showModal()
  }

  close() {
    this.element.close()
  }

  onCloseBtnClick = (_event: MouseEvent) => {
    this.close()
  }

  // @ts-ignore
  onEmailChanged = (e: Event) => this.sendBtn.disabled = !e.target.checkValidity()

  onSendEmailBtnClick = async (_: MouseEvent) => {
    this.sendBtn.disabled = this.emailInput.disabled = true
    const email = this.emailInput.value.trim()
    this.sendBtn.disabled = this.emailInput.disabled = false
    try {
      this.sendBtn.disabled = this.emailInput.disabled = true
      const response = await authService.sendEmail(email)
      const existingUser = response.existingUser
      this.close()
      this.sentCallBack(email, existingUser)
    } catch (error) {
      console.error(error)
    } finally {
      this.sendBtn.disabled = this.emailInput.disabled = false
    }
  }
}
